import './common-fields.scss';

import React from 'react';

export interface CheckboxFieldProps {
  checked: boolean;
  className?: string;
  description?: React.ReactNode;
  error?: string;
  id?: string;
  label: React.ReactNode;
  name?: string;
  required?: boolean;
  showError?: boolean;
  onChange: (val: boolean) => void;
}

export const CheckboxField = (props: CheckboxFieldProps) => {
  const { checked, className, description, error, id, label, name, required, showError, onChange } = props;

  return (
    <div className={`po-field po-checkbox-field ${className || ''}`.trim()}>
      <label htmlFor={id} className='po-checkbox-label'>
        <input id={id} name={name} type='checkbox' checked={checked} onChange={e => onChange(e.target.checked)} />
        <span className='po-checkbox-text'>
          {label}
          {required ? (
            <span className='req ms-1' aria-hidden>
              *
            </span>
          ) : null}
        </span>
      </label>
      {description ? <span>{description}</span> : null}
      {showError && error ? <div className='po-error inline'>{error}</div> : null}
    </div>
  );
};
